var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M568 216H576V128C576 92.654 547.346 64 512 64H64C28.654 64 0 92.654 0 128V216H8C30.125 216 48 233.875 48 256S30.125 296 8 296H0V384C0 419.346 28.654 448 64 448H512C547.346 448 576 419.346 576 384V296H568C545.875 296 528 278.125 528 256S545.875 216 568 216ZM528 177.625C499.5 192.25 480 221.875 480 256S499.5 319.75 528 334.375V384C528 392.837 520.837 400 512 400H64C55.163 400 48 392.837 48 384V334.375C76.5 319.75 96 290.125 96 256S76.5 192.25 48 177.625V128C48 119.163 55.163 112 64 112H512C520.837 112 528 119.163 528 128V177.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSimple);
export default __webpack_public_path__ + "static/media/ticket-simple.4de1ce687a05d47699606065728e57ea.svg";
export { ForwardRef as ReactComponent };